export const DEFAULT_GEO_LINESTRING_LINE_WIDTH = 3;
